import React from 'react'

const Loader = () => {
  return (
    <div className='h-screen w-full bg-black flex justify-center items-center'>
        <img  src="/images/Logo.png" alt="" />
    </div>
  )
}

export default Loader